module.exports = __webpack_public_path__ + "static/media/member1.27076bf6.png";